import type { GetProjectQueryParams } from '@gonfalon/openapi/operations/getProject';
import type { schemas } from '@gonfalon/openapi/types';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { projectsDetail } from './projectsDetail';

export function initializeProject({
  projectKey,
  params,
  project,
}: {
  projectKey: string;
  params?: GetProjectQueryParams;
  project: schemas['Project'];
}) {
  getQueryClient().setQueryData(projectsDetail({ projectKey, query: params }).queryKey, project);
}
